import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FcGoogle } from 'react-icons/fc'
import { FaFacebook } from 'react-icons/fa6'
import apiClient from '@/lib/api-client'

interface SocialButtonsProps {
  mode: 'login' | 'register'
  onError?: (message: string) => void
}

export default function SocialButtons({ mode, onError }: SocialButtonsProps) {
  const { t } = useTranslation('auth')
  const [localError, setLocalError] = useState('')

  const startOAuth = async (provider: 'google' | 'facebook') => {
    setLocalError('')
    try {
      const response = await apiClient.get<{ data: { redirect_url: string } }>(
        `/auth/social/${provider}`
      )
      const url = response.data?.data?.redirect_url
      if (url) {
        window.location.href = url
        return
      }
      const message = t('social.errors.noRedirect')
      setLocalError(message)
      onError?.(message)
    } catch (error: any) {
      console.error(`${provider} auth failed`, error)
      const message =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        t('social.errors.startFailed', { provider: provider === 'google' ? 'Google' : 'Facebook' })
      setLocalError(message)
      onError?.(message)
    }
  }

  return (
    <div className="space-y-3">
      {localError ? <p className="text-sm text-destructive">{localError}</p> : null}
      <button
        type="button"
        onClick={() => startOAuth('google')}
        className="flex w-full items-center justify-center gap-3 rounded-md border border-border bg-card px-4 py-2.5 text-sm font-medium text-foreground transition-colors hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        <FcGoogle className="h-5 w-5" />
        {mode === 'login' ? t('social.google.login') : t('social.google.register')}
      </button>

      <button
        type="button"
        onClick={() => startOAuth('facebook')}
        className="flex w-full items-center justify-center gap-3 rounded-md bg-[#1877f2] px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#166fe5] focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        <FaFacebook className="h-5 w-5" />
        {mode === 'login' ? t('social.facebook.login') : t('social.facebook.register')}
      </button>
    </div>
  )
}
